var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70922 0.00822632C11.5571 -0.0990844 13.9873 0.843491 16 2.83596C15.1473 3.70002 14.2842 4.55174 13.4108 5.39114C11.5554 3.7114 9.44314 3.29126 7.07391 4.13058C4.27874 5.59903 3.2226 7.88165 3.90548 10.9785C4.66699 13.2392 6.22279 14.5678 8.57294 14.9645C10.449 15.1797 12.0502 14.6232 13.3767 13.2952C14.217 14.1355 15.0574 14.9759 15.8978 15.8163C15.9488 15.8936 15.9375 15.9617 15.8637 16.0207C13.269 18.3952 10.2483 19.1788 6.80135 18.3715C2.82897 17.047 0.569079 14.3101 0.0216094 10.1608C-0.190648 6.55432 1.16076 3.7039 4.07583 1.60947C5.49147 0.677125 7.03588 0.143378 8.70922 0.00822632Z",
    fill: "#FDFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.6d73271f5570ae31268a651b68f1cf34.svg";
export { ForwardRef as ReactComponent };